const r = () => ({
  path: {
    fill: "currentColor"
  }
});
export {
  r as inheritIconColor
};
